<template>
    <div class="search-huddle-new float-right relative tw-flex tw-flex-1 tw-justify-end">
        <i class="fa fa-search hover-opacity" @click="toggleSearch"></i>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'MenuSearch',

        computed: {
            ...mapState([
                'full_screen_search_open'
            ])
        },

        methods: {
            toggleSearch() {
                //remove params from url if closing
                if(this.full_screen_search_open) {
                    let params = new URLSearchParams(location.search);

                    if(params.has('search')) {
                        params.delete('search');
                    }

                    if(params.has('order_by')) {
                        params.delete('order_by');
                    }

                    window.history.replaceState({}, '', `${location.pathname}?${params}`);
                }

                this.$store.commit('toggleFullScreenSearch');
            }
        }
    }
</script>